
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wrap",
      function () {
        return require("private-next-pages/wrap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wrap"])
      });
    }
  